import { useContext } from 'react';

import { FaceMissingContext } from '../context';
import { FaceMissingContextProps } from '../context/types';

export function useFaceMissing(): FaceMissingContextProps {
    return useContext(FaceMissingContext);
}
